import {  Form as FormikForm } from "formik";
import styled from "styled-components";
import { Assets } from "./assets";

export const Form = styled(FormikForm)`
  width: 350px;
  height: auto;
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  background-color:${Assets.backgroundForm};
  border: 1px solid ${Assets.secondaryColor};
  border-radius: ${Assets.borderRadiusForm};
  padding: 25px;  
  
`;
